/**
 * Bestsellers [New]
 * Carousel + reveals + ATC via theme.ProductForm / ajaxProduct:added
 */
(function () {
  'use strict';

  var SECTION_TYPE = 'bestsellers-new';
  var instances = new WeakMap();

  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function Bestsellers(root) {
    this.root = root;
    this.viewport = root.querySelector('[data-bs-viewport]');
    this.track = root.querySelector('[data-bs-track]');
    this.controls = root.querySelector('[data-bs-controls]');
    this.progressWrap = root.querySelector('[data-bs-progress-wrap]');
    this.btnPrev = root.querySelector('[data-bs-prev]');
    this.btnNext = root.querySelector('[data-bs-next]');
    this.currentEl = root.querySelector('[data-bs-current]');
    this.totalEl = root.querySelector('[data-bs-total]');
    this.progressEl = root.querySelector('[data-bs-progress]');
    this.index = 0;
    this.observers = [];
    this.productForms = [];
    this.reducedMotion =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.refreshSlides();
    this.initAtcForms();
    this.initReveals();

    if (!this.track || this.slides.length === 0) return;

    this.updateChromeVisibility();
    this.bind();
    this.goTo(0, true);
  }

  Bestsellers.prototype.refreshSlides = function () {
    this.slides = Array.prototype.slice.call(
      this.root.querySelectorAll('[data-bs-slide]')
    );
  };

  Bestsellers.prototype.visibleColumns = function () {
    if (!this.root) return 1;
    var desktop =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(min-width: 769px)').matches;
    var styles = window.getComputedStyle(this.root);
    var raw = styles.getPropertyValue(
      desktop ? '--vg-bs-cols-desktop' : '--vg-bs-cols-mobile'
    );
    var n = parseInt(raw, 10);
    return n > 0 ? n : 1;
  };

  Bestsellers.prototype.updateChromeVisibility = function () {
    var canScroll = this.maxIndex() > 0;
    var steps = this.maxIndex() + 1;
    if (this.controls) this.controls.hidden = !canScroll;
    if (this.progressWrap) this.progressWrap.hidden = !canScroll;
    if (this.totalEl) this.totalEl.textContent = pad2(steps);
  };

  Bestsellers.prototype.slideStep = function () {
    if (!this.slides[0]) return 0;
    return this.slides[0].getBoundingClientRect().width;
  };

  Bestsellers.prototype.maxIndex = function () {
    if (this.slides.length === 0) return 0;
    return Math.max(0, this.slides.length - this.visibleColumns());
  };

  Bestsellers.prototype.initAtcForms = function () {
    var self = this;
    var forms = this.root.querySelectorAll('.vg-pc__atc-form');

    forms.forEach(function (form) {
      if (form.dataset.vgPcBound) return;
      form.dataset.vgPcBound = '1';

      if (window.theme && theme.ProductForm) {
        try {
          self.productForms.push(new theme.ProductForm(form, '.add-to-cart', {}));
          return;
        } catch (e) {
          /* fall through to manual handler */
        }
      }

      form.addEventListener('submit', function (evt) {
        evt.preventDefault();
        var btn = form.querySelector('[data-add-to-cart]');
        if (btn) btn.classList.add('btn--loading');

        var data = new FormData(form);
        var addUrl =
          (theme.routes && theme.routes.cartAdd) ||
          (window.routes && window.routes.cart_add_url) ||
          '/cart/add.js';

        fetch(addUrl, {
          method: 'POST',
          body: data,
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin',
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (payload) {
            if (btn) btn.classList.remove('btn--loading');
            if (payload && payload.status === 422) return;

            if (theme.settings && theme.settings.cartType === 'page') {
              window.location = theme.routes.cartPage || '/cart';
              return;
            }

            document.dispatchEvent(
              new CustomEvent('ajaxProduct:added', {
                detail: { product: payload, addToCartBtn: btn },
                bubbles: true,
              })
            );
          })
          .catch(function () {
            if (btn) btn.classList.remove('btn--loading');
          });
      });
    });
  };

  Bestsellers.prototype.goTo = function (i, instant) {
    var max = this.maxIndex();
    var total = this.slides.length;
    if (total === 0) return;

    var next = this.index;
    if (i > this.index) {
      next = this.index >= max ? 0 : Math.min(this.index + 1, max);
    } else if (i < this.index) {
      next = this.index <= 0 ? max : Math.max(this.index - 1, 0);
    } else {
      next = Math.min(Math.max(i, 0), Math.max(max, 0));
    }

    this.index = next;
    var x = this.index * this.slideStep();
    if (instant) this.track.style.transition = 'none';
    this.track.style.transform = 'translate3d(' + -x + 'px,0,0)';
    if (instant) {
      void this.track.offsetWidth;
      this.track.style.transition = '';
    }
    this.updateUI();
  };

  Bestsellers.prototype.updateUI = function () {
    var steps = this.maxIndex() + 1;
    if (this.currentEl) this.currentEl.textContent = pad2(this.index + 1);
    if (this.totalEl) this.totalEl.textContent = pad2(steps);
    if (this.progressEl && steps > 0) {
      this.progressEl.style.width = ((this.index + 1) / steps) * 100 + '%';
    }
  };

  Bestsellers.prototype.bind = function () {
    var self = this;
    if (this.btnPrev) {
      this.btnPrev.addEventListener('click', function () {
        self.goTo(self.index - 1);
      });
    }
    if (this.btnNext) {
      this.btnNext.addEventListener('click', function () {
        self.goTo(self.index + 1);
      });
    }

    window.addEventListener('resize', function () {
      self.refreshSlides();
      self.updateChromeVisibility();
      self.goTo(self.index, true);
    });

    var startX = 0;
    var startTransform = 0;
    var pointerActive = false;
    var dragging = false;
    var dragMoved = false;
    var activePointerId = null;

    function getX() {
      var m = /translate3d\((-?\d+(?:\.\d+)?)px/.exec(self.track.style.transform || '');
      return m ? parseFloat(m[1]) : 0;
    }

    function releasePointer(e) {
      if (activePointerId == null) return;
      try {
        if (self.viewport.hasPointerCapture(activePointerId)) {
          self.viewport.releasePointerCapture(activePointerId);
        }
      } catch (err) {}
      activePointerId = null;
    }

    this.viewport.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;
      if (e.target.closest('button, form, input')) return;
      pointerActive = true;
      dragging = false;
      dragMoved = false;
      startX = e.clientX;
      startTransform = getX();
      activePointerId = e.pointerId;
    });

    this.viewport.addEventListener('pointermove', function (e) {
      if (!pointerActive) return;
      var dx = e.clientX - startX;

      // Only treat as a drag after a clear movement threshold
      if (!dragging && Math.abs(dx) > 10) {
        dragging = true;
        dragMoved = true;
        self.track.style.transition = 'none';
        self.viewport.classList.add('is-dragging');
        try {
          self.viewport.setPointerCapture(e.pointerId);
          activePointerId = e.pointerId;
        } catch (err) {}
      }

      if (!dragging) return;
      self.track.style.transform = 'translate3d(' + (startTransform + dx) + 'px,0,0)';
    });

    function endDrag(e) {
      if (!pointerActive) return;
      pointerActive = false;
      self.viewport.classList.remove('is-dragging');
      self.track.style.transition = '';
      releasePointer(e);

      if (!dragging) {
        dragging = false;
        return;
      }

      dragging = false;
      var dx = e.clientX - startX;
      var step = self.slideStep();
      if (Math.abs(dx) > step * 0.2) {
        self.goTo(self.index + (dx < 0 ? 1 : -1));
      } else {
        self.goTo(self.index);
      }
    }

    this.viewport.addEventListener('pointerup', endDrag);
    this.viewport.addEventListener('pointercancel', endDrag);

    this.viewport.addEventListener(
      'click',
      function (e) {
        if (!dragMoved) return;
        var link = e.target.closest('a');
        if (!link) return;
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );
  };

  Bestsellers.prototype.initReveals = function () {
    var cards = this.root.querySelectorAll('[data-reveal="card"]');
    var bars = this.root.querySelectorAll('.vg-intensity-bar');

    if (this.reducedMotion || typeof IntersectionObserver === 'undefined') {
      cards.forEach(function (el) {
        el.classList.add('is-inview');
      });
      bars.forEach(function (el) {
        el.classList.add('is-inview');
      });
      return;
    }

    var cardObs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = el.getAttribute('data-reveal-delay') || '0';
          el.style.transitionDelay = delay + 'ms';
          el.classList.add('is-inview');
          cardObs.unobserve(el);
        });
      },
      { rootMargin: '-80px 0px -80px 0px', threshold: 0 }
    );
    cards.forEach(function (el, i) {
      if (!el.getAttribute('data-reveal-delay')) {
        el.setAttribute('data-reveal-delay', String((i % 4) * 60));
      }
      cardObs.observe(el);
    });
    this.observers.push(cardObs);

    var barObs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-inview');
          barObs.unobserve(entry.target);
        });
      },
      { rootMargin: '-40px 0px -40px 0px', threshold: 0 }
    );
    bars.forEach(function (el) {
      barObs.observe(el);
    });
    this.observers.push(barObs);
  };

  Bestsellers.prototype.destroy = function () {
    this.observers.forEach(function (o) {
      o.disconnect();
    });
    this.observers = [];
  };

  function initRoot(root) {
    if (!root) return;
    if (instances.has(root)) {
      instances.get(root).destroy();
      instances.delete(root);
    }
    instances.set(root, new Bestsellers(root));
  }

  function destroyRoot(root) {
    if (!root || !instances.has(root)) return;
    instances.get(root).destroy();
    instances.delete(root);
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]')
      .forEach(initRoot);
  }

  function findRoot(el) {
    if (!el) return null;
    if (el.matches && el.matches('[data-section-type="' + SECTION_TYPE + '"]')) return el;
    return el.querySelector
      ? el.querySelector('[data-section-type="' + SECTION_TYPE + '"]')
      : null;
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });
  if (document.readyState !== 'loading') initAll(document);

  document.addEventListener('shopify:section:load', function (e) {
    var root = findRoot(e.target);
    if (root) initRoot(root);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = findRoot(e.target);
    if (root) destroyRoot(root);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var root = findRoot(e.target);
    if (root) initRoot(root);
  });
})();
